export default __webpack_public_path__ + "static/media/logo.29b8643c.svg";